import { WorkOrderHistory } from "components/QueueBoard/models/workOrderTypes";
import { EntityTypeEnum, ItemTypeEnum } from "../enums/workOrderActivity.enums";

export const fieldDisplayNames: Record<string, string> = {
  //Invoice Header
  WODescription: "Work Order Description",
  CustomerName: "Customer Name",
  StartDate: "Start Date",
  ModDate: "Modified Date",
  StdJobSteps: "Standard Job Steps",
  DisplayText: "Display Text",
  FlatRateLaborHrs: "Flat Rate Labor Hours",
  ShopSuppAmt: "Shop Supply Amount",
  WOUnitNo: "Unit Number",
  WOMeter: "Meter",
  WOUnitModel: "Unit Model",
  WOMeterDate: "Meter Date",
  WOWarrantyDate: "Warranty Date",
  WOPickupDate: "Pickup Date",
  WODeliveryDate: "Delivery Date",
  PORefNo: "Purchase Order Number",
  LocTaxGroupId: "Location Tax Group",
  WODisplayText: "My Reference",
  NonPrintableComment: "Non-Printable Comment",
  WOStatusId: "Work Order Status",
  SalesPersonId: "Sales Person",
  LocationId: "Location",
  WOTechId: "Technician",
  WOPriorityId: "Priority",
  WOMeterType: "Meter Type",
  WOUnitBaseSerial: "Unit Base Serial",
  //Invoice Segment
  LaborRate: "Labor Rate",
  SvcCodeId: "Service Code",
  HasLabor: "Has Labor",
  HasMiscCharge: "Has Misc Charge",
  HasParts: "Has Parts",
  LastName: "Last Name",
  PrintableComment: "Printable Comment",
  WOUnitDescription: "Unit Description",
  WOUnitIsAttachment: "Is Unit an Attachment?",
  AltContactName: "Alternate Contact Name",
  AltContactPhone: "Alternate Contact Phone",
  WOUnitNoSearchType: "Unit Search Type",
  ActualHrs: "Actual Hours",
  SegmentName: "Segment Name",
  TotalInvoice: "Total Invoice",
  DeliverToShippingAddress: "Deliver to Shipping Address",
  CommittedDate: "Committed Date",
  CommittedBy: "Committed By",
  WoSearchType: "Search Type",
  ClosedBy: "Closed By",
  FinalizedDate: "Finalized Date",
  FinalizedBy: "Finalized By",
  VoidedDate: "Voided Date",
  ClosedDate: "Closed Date",
  VoidedBy: "Voided By",
  DefaultDeliver: "Default Delivery",
  ShippingNote: "Shipping Note",
  SigCapType: "Signature Capture Type",
  ActivityDate: "Activity Date",
  CustomerNo: "Customer Number",
  BillingAdd1: "Billing Address Line 1",
  RequiredStartTime: "Required Start Time",
  RequiredWaitUntilDate: "Required Wait Until Date",
  RequiredEndTime: "Required End Time",
  ScheduledStartTime: "Scheduled Start Time",
  ScheduledEndTime: "Scheduled End Time",
  ActualStartTime: "Actual Start Time",
  ActualEndTime: "Actual End Time",
  TechComment: "Technician Comment",
  EntBy: "Entered By",
  EntDate: "Entered Date",
  ModBy: "Modified By",
  IsActive: "Is Active",
  IsClock: "Is Clocked",
  TechId: "Technician",
  StdJobUnitModelId: "Standard Job Unit Model",
  JEHeaderId: "Journal Entry Header",
  TechName: "Technician Name",
  StdJobRecommendedHrs: "Recommended Job Hours",
  ParentQuoteId: "Parent Quote",
  OrigFileName: "Original File Name",
  StartTime: "Start Time",
  StdJobCode: "Standard Job Code",
  WOUnitTag: "Unit Tag",
  QuoteNo: "Quote Number",
  BillingAdd2: "Billing Address Line 2",
  EndTime: "End Time",
  StdJobSource: "Standard Job Source",
  WOUnitIsNew: "Is New Unit",
  UnitPrice: "Unit Price",
  StdJobDescription: "Job Description",
  BillingPhone: "Billing Phone",
  IsManualBillRecurr: "Is Manual Recurring Billing",
  LineNumber: "Line Number",
  LaborDiscPct: "Labor Discount (%)",
  ShopSuppTaxExemptId: "Shop Supply Tax Exempt",
  IsDefault: "Is Default",
  QtyDelivered: "Quantity Delivered",
  LaborDiscAmt: "Labor Discount Amount",
  BillingZip: "Billing Zip Code",
  BillingEmail: "Billing Email",
  VendorQty: "Vendor Quantity",
  BillAs: "Bill As",
  BillingCity: "Billing City",
  BillingState: "Billing State",
  ShippingAddress1: "Shipping Address Line 1",
  NetExt: "Net Extended",
  OrderNumber: "Order Number",
  StdJobHeaderId: "Standard Job Header",
  CustomerId: "Customer",
  OrderGroupId: "Order Group",
  ActualHours: "Actual Hours",
  FirstName: "First Name",
  WarrSubmissionTypeId: "Warranty Submission Type",
  QtyRecv: "Quantity Received",
  ShopFeeAmt: "Shop Fee Amount",
  ShopFeePct: "Shop Fee (%)",
  MiddleName: "Middle Name",
  MetaXML: "Meta XML",
  MetaText: "Meta Text",
  VendorId: "Vendor",
  MaxShopFee: "Maximum Shop Fee",
  POReq: "PO Required",
  IsPublic: "Is Public",
  TotalCost: "Total Cost",
  OrderType: "Order Type",
  EstimatedHours: "Estimated Hours",
  BillingCountry: "Billing Country",
  QtyOrdered: "Quantity Ordered",
  SubmissionType: "Submission Type",
  BillingCounty: "Billing County",
  ShippingAddress2: "Shipping Address Line 2",
  WorksheetType: "Worksheet Type",
  OrderDiscount: "Order Discount",
  SubmissionRefNo: "Submission Reference Number",
  ShippingCity: "Shipping City",
  DiscountAmt: "Discount Amount",
  MayFlowSchedule: "May Flow Schedule",
  ShippingState: "Shipping State",
  DiscountPct: "Discount (%)",
  OrderDate: "Order Date",
  ExpectedDate: "Expected Date",
  SubmittedDate: "Submitted Date",
  LocationFromId: "From Location",
  LocationToId: "To Location",
  ExchCost: "Exchange Cost",
  DropShipName: "Drop Ship Name",
  DropShipAdd1: "Drop Ship Address Line 1",
  DropShipAdd2: "Drop Ship Address Line 2",
  ExchDiscount: "Exchange Discount",
  DropShipCity: "Drop Ship City",
  ExchangeRate: "Exchange Rate",
  FollowUp: "Follow Up",
  DropShipState: "Drop Ship State",
  DropShipZip: "Drop Ship Zip",
  DropShipCountry: "Drop Ship Country",
  InterfaceMeta: "Interface Metadata",
  ProcessedDate: "Processed Date",
  DropShipEmailAddr: "Drop Ship Email",
  DropShipPhone: "Drop Ship Phone",
  InterfaceText: "Interface Text",
  OwnerId: "Owner",
  ExchangeRateId: "Exchange Rate",
  AltTaxGroupId: "Alternate Tax Group",
  InvoiceFormat: "Invoice Format",
  WOEstimate: "Work Order Estimate",
  WOUnitId: "Work Order Unit",
  ShippingTaxGroupId: "Shipping Tax Group",
  ShippingPhone: "Shipping Phone",
  DiscountMarkup: "Discount Markup",
  ShippingCountry: "Shipping Country",
  UsePrePrintedPaper: "Use Pre-Printed Paper",
  NonLaborTaxExemptId: "Non-Labor Tax Exempt",
  ZoneId: "Zone",
  UseAltTax: "Use Alternate Tax",
  LaborTaxExemptId: "Labor Tax Exempt",
  WeightKgs: "Weight (kg)",
  JurisdictionDisplayText: "Jurisdiction",
  TaxableAmount: "Taxable Amount",
  NonTaxableAmount: "Non Taxable Amount",
  TotalSales: "Total Sales",
  TotalTax: "Total Tax",
  TotalTrade: "Total Trade",
  AltTax: "Alternate Tax",
  RentalUseTax: "Rental Uses Tax",
  PrintInvAs: "Print Invoice As",
  TemplateId: "Template",
  SegmentId: "Segment",
  IsComplete: "Is Complete?",
  EnteredBy: "Created By",
  EnteredDate: "Created Date",
  ModifiedBy: "Modified By",
  ModifiedDate: "Modified Date",
  CustomerAltAddressId: "Customer Alternate Address",
  InvoiceLaborAdjustmentCode: "Labor Adjustment Code",
  TimeOn: "Time On",
  TimeOff: "Time Off",
  ElapsedHours: "Elapsed Hours",
};

export type WorkOrderAttachmentActivityProps = {
  attachmentHistory: WorkOrderHistory;
};

export type WorkOrderActivityProps = {
  activities: WorkOrderHistory[];
  setCurrentTabIndex: React.Dispatch<React.SetStateAction<number>>;
};

const itemTypeLabelMap: Record<ItemTypeEnum, string> = {
  [ItemTypeEnum.Part]: "Part - ",
  [ItemTypeEnum.QuoteUnit]: "Quote Unit - ",
  [ItemTypeEnum.Remark]: "Remark - ",
  [ItemTypeEnum.RentalUnit]: "Rental Unit - ",
  [ItemTypeEnum.Labor]: "Labor - ",
  [ItemTypeEnum.TradeIn]: "Trade Ins - ",
  [ItemTypeEnum.Misc]: "Miscellaneous Charge- ",
  [ItemTypeEnum.Unit]: "Unit - ",
};

export const entityLabelMap: Record<
  EntityTypeEnum,
  (history: WorkOrderHistory) => React.ReactNode
> = {
  [EntityTypeEnum.InvHead]: (h) => (
    <>
      Work Order# <strong>{h.docNo}</strong>
    </>
  ),
  [EntityTypeEnum.InvSeg]: (h) => (
    <>
      Segment: <strong>{h.segmentName}</strong>
    </>
  ),
  [EntityTypeEnum.SegComment]: (h) => (
    <>
      <strong>{h.segmentName}</strong>
    </>
  ),
  [EntityTypeEnum.SegItems]: (h) => {
    const itemLabel = itemTypeLabelMap[h.itemType as ItemTypeEnum] || "";
    return (
      <>
        {itemLabel} <strong>{h.displayText}</strong>
      </>
    );
  },
  // Created dummy comment
  [EntityTypeEnum.SegAttachment]: (h) => " Attached File To " + h.segmentName,
  [EntityTypeEnum.SegCheckList]: (h) => " Checklist " + h.segmentName,
  [EntityTypeEnum.SegAttachmentImage]: (h) => " Image To " + h.segmentName,
  [EntityTypeEnum.SegLabor]: (h) => {
    return (
      <>
        Clocking on Segment: <strong>{h.segmentName}</strong>
      </>
    );
  },
  [EntityTypeEnum.invSegTask]: (h) => " Segment Task " + h.segmentName,
  [EntityTypeEnum.serviceSchedule]: (h) => " Service Schedule " + h.segmentName,
  [EntityTypeEnum.workOrderSchedule]: (h) =>
    " Work Order #" + h.displayText + " Schedule",
  [EntityTypeEnum.partOrderHeader]: (h) => " Part Order: " + h.displayText,
  [EntityTypeEnum.PartOrderLine]: (h) => " Part Order Line:  " + h.displayText,
};
